module.exports = __webpack_public_path__ + "30619525f42190bcc636a1c47f963e58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg1.jpg
// module id = 170
// module chunks = 1